<template>
  <div class="container">
    <h1>Billing Run Statistic</h1>
    <div id="outbox-content">
      <Bar id="chartBar" ref="chartBar" :data="chartData" :options="chartOptions" style="height: 70vh"/>
    </div>
  </div>
</template>

<script>
import {Bar} from 'vue-chartjs'
import {logger} from "@/services/logger.service";
import billingOverviewService from '../service'

export default {
  components: {
    Bar,
  },
  data: function () {
    return {
      chartData: {
        "labels": [
          "Loading..."
        ],
        "datasets": [
          {
            "label": "Loading...",
            "backgroundColor": "white",
            "data": [0]
          }
        ]
      },
      //https://www.chartjs.org/docs/latest/general/options.html
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            stacked: true,
          },
          y: {
            stacked: true
          }
        },
        //https://www.chartjs.org/docs/latest/developers/api.html
        //https://stackoverflow.com/questions/49249902/select-all-and-unselect-option-for-chart-js
        plugins: {
          legend: {
            display: true,
            labels: {
              fontsize: 8,
              boxWidth: 10
            },
            onClick: (evt, legendItem, legend) => {
              legend.chart.data.datasets.forEach((dataset, i) => {
                if (legendItem.text == "Show/Hide All" || dataset.label.replace(/\s*\(.*\)$/, "") == legendItem.text.replace(/\s*\(.*\)$/, "")) {
                  legend.chart.setDatasetVisibility(i, legend.hideAll)
                }
              });

              legend.hideAll = !legend.hideAll;
              legend.chart.update();

              return;
            }
          }
        }
      }
    }
  },
  async mounted() {
    logger.debug('Component mounted.')
    const response = await billingOverviewService.getBillingStatistics(24);
    this.chartData = response.data;

    this.chartData.datasets.unshift({label: "Show/Hide All", backgroundColor: "white"});
    logger.debug("BillingOverview - chartData", JSON.stringify(this.chartData));
  },
  methods: {
  },
}
</script>

<style>

</style>
